/**
 * Lightweight event bus for quota-exceeded errors.
 * The API interceptor fires events here; the QuotaExceededModal listens.
 */

export interface QuotaErrorPayload {
  resource: string;
  current: number;
  limit: number;
  message: string;
}

type Listener = (payload: QuotaErrorPayload) => void;

const listeners = new Set<Listener>();

export function onQuotaExceeded(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function fireQuotaExceeded(payload: QuotaErrorPayload): void {
  listeners.forEach((fn) => fn(payload));
}
